import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { logService } from '../../services';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

var chartOptions = {
  responsive: true,
  aspectRation: 1,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'CC Calls Requested From Dialer',
    },
  },
};

// {
//         labels: labels,
//         datasets: [
//             {
//             label: 'Dataset 1',
//             data: labels.map(() => Math.random() * 100),
//             backgroundColor: 'rgba(255, 99, 132, 0.5)',
//             },
//             {
//             label: 'Dataset 2',
//             data: labels.map(() => Math.random() * 100),
//             backgroundColor: 'rgba(53, 162, 235, 0.5)',
//             },
//         ],
//     }


// const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', '1', '2', '3', '4', '5', '6']
export default function CallVolume(props) {
    const [data, setData] = React.useState({
        labels: [],
            datasets: [],
    })
    let defaultDate = new Date();
    defaultDate = new Date(defaultDate.getTime() + (3600000 * 10))
    defaultDate.setHours(0, 0, 0)
    defaultDate.setMonth(new Date().getMonth())
    defaultDate.setDate(new Date().getDate())
    const [start, setStart] = React.useState(Math.floor((defaultDate.getTime())/1000)); //todo get a timestamp from midnight today!
    const [logs, setLogs] = React.useState([]);
    const [triggerUpdate, setTriggerUpdate] = React.useState(false);

    React.useEffect(() => {
        fetchData();
        const id = window.setInterval(() => setTriggerUpdate(true), 60000);
        return () => window.clearInterval(id);
    }, []);

    React.useEffect(() => {
        if (triggerUpdate) {
            fetchData(start)
            setTriggerUpdate(false)
        }
    }, [triggerUpdate])

    React.useEffect(() => {
        processLogsToData();
    }, [logs])

    const fetchData = (update) => {
        if (!update) update = start;
        logService.getLogs(update).then(resp => {
        // prepend new data when start is used to fetch logs.
        if (update === start) {
            setLogs(logs => [...resp.Data, ...logs]);
        } else {
            setLogs(resp.Data);
        }
        if (resp?.Data?.length > 0) {
            setStart(Math.floor((new Date(resp.Data[0].CreatedAt).getTime()) / 1000));
        }
        });
    }

    const processLogsToData = () => {
        let labels = []
        let datasets = [];
        let filteredData = {};
        //go thru all the logs, if there is a call dialled update a users calls at once
        // console.log(logs)
        logs.map((l) => {
            // if (l.User.toLower().includes('deb')) {
            //     return;
            // }
            if (l.Action === "Call dialed") {
                if (filteredData[l.User]) {
                    filteredData[l.User]['all']++
                    filteredData[l.User]['deals'][l.ExternalReference] = 1
                } else {
                    filteredData[l.User] = {}
                    filteredData[l.User]['all'] = 1;
                    filteredData[l.User]['deals'] = {};
                    filteredData[l.User]['deals'][l.ExternalReference] = 1
                    filteredData[l.User]['added'] = 0

                }
            } else if (l.Action === 'Call added' && l.User !== "Instyle CRM" && l.Priority === 'FreshLeads' ) {
                if (filteredData[l.User]) {
                    filteredData[l.User]['added']++
                } else {
                    filteredData[l.User] = {}
                    filteredData[l.User]['all'] = 0;
                    filteredData[l.User]['deals'] = {};
                    filteredData[l.User]['added'] = 1;
                }
            }

        });
        filteredData = Object.entries(filteredData);
        filteredData = filteredData.sort((a, b) => b[1]['all'] - a[1]['all']);
        //now create a dataset to add to the graph
        datasets = [
            {
                label: 'Calls Dialled',
                backgroundColor: 'rgba(0, 0, 255, 0.5)',
                data: filteredData.map((v) => {
                    return v[1]['all'];
                })
            },
            {
                label: 'Unique Deals',
                backgroundColor: 'rgba(9, 55, 95, 0.5)',
                data: filteredData.map(v => {
                    return Object.entries(v[1]['deals']).length
                })
            },
            {
                label: 'Deals Added',
                backgroundColor: 'rgba(16, 109, 186, 0.5)',
                data: filteredData.map(v => {
                    return v[1]['added'];
                })
            }
        ]

        let data = {
            labels: filteredData.map((v) => {
                    return v[0];
                }),
            datasets: datasets,
        }
        setData(data)
    }

    const sort = (obj,valSelector) => {
        const sortedEntries = Object.entries(obj)
            .sort((a, b) =>
            valSelector(a[1]) > valSelector(b[1]) ? 1 :
            valSelector(a[1]) < valSelector(b[1]) ? -1 : 0);
        return new Map(sortedEntries);
    }

    return (
        <div style={{padding: '25px'}}>
            <div style={{textAlign: 'center'}}>From {defaultDate.toLocaleString()} to {new Date(start * 1000).toLocaleString()}</div>
            <div style={{position: 'relative', height: '550px', margin: 'auto'}}>
                <Bar options={chartOptions} height={null} width={null} data={data} />
            </div>

        </div>

    )
}
